"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
let ForceVDExitDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.onlineDatas = [];
    this.allData = null;
    this.clientVersion = "6.8.1";
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open(item) {
    return __async(this, null, function* () {
      try {
        this.allData = item;
        this.onlineDatas = item.onLineList.datas;
        this.dialog.visible = true;
      } catch (error) {
      }
    });
  }
  close() {
    this.dialog.visible = false;
  }
  getVersion() {
    return __async(this, null, function* () {
      try {
        let version_response = yield API.get(`api://base.local/update/version`);
        let _version = version_response.data.version;
        this.clientVersion = _version;
      } catch (error) {
        console.log(error);
      }
    });
  }
  forceOffline(data) {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.warnconfirm(
          this.$t("forceexitdialog.before_force_vd_exit_tip.message", {
            name: data.name,
            vd_name: this.allData.name
          }),
          this.$t("headertoolbar.hint"),
          {
            confirmButtonText: this.$t("headertoolbar.confirm"),
            cancelButtonText: this.$t("headertoolbar.cancel"),
            iconClass: "el-icon-warning"
          }
        );
        let arr = [];
        arr.push(data.userId);
        let deleteUser = {
          vdId: this.allData.oldId,
          userIds: arr
        };
        yield API.delete(`api://base.auth.message/v1/user-shops`, {
          data: deleteUser
        });
        this.$message.success(
          this.$t("forceexitdialog.deleteSuccess.message")
        );
        this.close();
        this.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
ForceVDExitDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], ForceVDExitDialog);
export {
  ForceVDExitDialog as default
};
